export enum EventType {
    UserActivatedCoupon = 'userActivatedCoupon',
    UserDeactivatedCoupon = 'userDeactivatedCoupon',
    ShifuCurrencyChange = 'shifu-currency-change',
    ChanchitoCuponEvent = 'chanchitoCuponEvent',
    ChangeCurrencyEvent = 'changeCurrency',
}